import { EditorView, WidgetType } from '@uiw/react-codemirror'
import { assetChipEditableFacet, onEditAssetFacet } from './assetReferenceDecoration'

export class AssetChipWidget extends WidgetType {
  constructor(
    private readonly label: string,
    private readonly uuid: string,
    private readonly typeId: string | undefined,
    private readonly from: number,
    private readonly to: number,
    private readonly versionId: string | undefined = undefined
  ) {
    super()
  }

  toDOM(view: EditorView): HTMLElement {
    const span = document.createElement('span')
    span.className = 'cm-asset-chip'

    if (this.typeId) {
      const link = document.createElement('a')
      link.className = 'cm-asset-chip-label'
      link.textContent = this.label
      const query = this.versionId ? `?versionId=${this.versionId}` : ''
      link.href = `/entities/${this.typeId}/edit/${this.uuid}${query}`
      link.target = '_blank'
      link.addEventListener('mousedown', (e) => {
        e.stopPropagation()
      })
      span.appendChild(link)
    } else {
      const labelSpan = document.createElement('span')
      labelSpan.textContent = this.label
      span.appendChild(labelSpan)
    }

    span.title = this.versionId ? `${this.uuid}@${this.versionId}` : this.uuid

    if (view.state.facet(assetChipEditableFacet)) {
      const editBtn = document.createElement('span')
      editBtn.className = 'cm-asset-chip-edit'
      editBtn.textContent = 'Edit'
      const { from, to } = this
      editBtn.addEventListener('mousedown', (e) => {
        e.preventDefault()
        e.stopPropagation()
        const callback = view.state.facet(onEditAssetFacet)
        callback({ from, to })
      })
      span.appendChild(editBtn)
    }

    return span
  }

  eq(other: AssetChipWidget): boolean {
    return (
      this.label === other.label &&
      this.uuid === other.uuid &&
      this.typeId === other.typeId &&
      this.from === other.from &&
      this.to === other.to &&
      this.versionId === other.versionId
    )
  }

  ignoreEvent(event: Event): boolean {
    const target = event.target
    return (
      target instanceof HTMLElement &&
      (target.classList.contains('cm-asset-chip-edit') || target.classList.contains('cm-asset-chip-label'))
    )
  }
}
